// 0015: in-flight request de-duplication. Returns the SAME pending promise for concurrent calls
// sharing a key, so two near-simultaneous identical GETs collapse into ONE network request. This
// makes shared bootstrap fetches exactly-once even under React 18 StrictMode (which invokes the
// React Query queryFn twice on mount) — without relying on RQ's internal dedup. The entry is
// cleared once the promise settles, so a later (post-cache) call issues a fresh request.
const inFlight = new Map();

export const dedupeRequest = (key, requestFn) => {
  if (inFlight.has(key)) return inFlight.get(key);
  const promise = Promise.resolve()
    .then(requestFn)
    .finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
};
